<template>
  <VersionSelect v-if="plp_task_id && versionListReady" last need-plp-data>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <CostCalc
        :value="data"
        :readonly="readonly"
        :onCreate="onCreate"
        @change="onChange"
        @blur="onBlur"
      />
    </template>
    <template #prepend-bottom="{ is_completed, data }">
      <btn-with-confirm
        v-if="data && is_completed"
        :loading="loading"
        left
        iconMain="mdi-check-bold"
        color="primary"
        @click="setComplete(false)"
        title="Расчёт затрат не готово к выгрузке - требуется доработка"
        >Расчёт затрат - не готово!</btn-with-confirm
      >
      <btn-with-confirm
        v-else-if="data"
        :loading="loading"
        left
        iconMain="mdi-arrow-up-left-bold"
        color="success"
        @click="setComplete(true)"
        title="Расчёт затрат готово к выгрузке"
        >Расчёт затрат - готово</btn-with-confirm
      >
    </template>
    <template #bottom><span /></template>
  </VersionSelect>
</template>

<script>
import VersionSelect from '@/components/VersionSelect'
import { mapActions, mapGetters } from 'vuex'
import btnWithConfirm from '@/components/buttons/btnWithConfirm'
import CostCalc from '@/components/expCost/CostCalc'

export default {
  name: 'MedicineCost',
  components: { CostCalc, VersionSelect, btnWithConfirm },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['plp_task_id', 'versionListReady']),
  },
  methods: {
    ...mapActions(['UPDATE_PLP_TASK', 'UPDATE_PLP_TASK_REWORK']),
    async setComplete(is_completed = false) {
      this.loading = true
      try {
        if (is_completed) {
          await this.UPDATE_PLP_TASK({
            is_completed,
          })
        } else {
          await this.UPDATE_PLP_TASK_REWORK()
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
